import React from 'react';

export const Loading = () => <div className="loader center ma4" />;



// WEBPACK FOOTER //
// ./src/components/Loading.jsx